// extracted by mini-css-extract-plugin
export default {"Carousel":"carousel_Carousel__ZmU4I"};